export function orderedEnumArray<T extends string>(enumObject: Record<string, T>, arr: T[]): T[] {
    const allEnumValues = Object.values(enumObject).filter((value): value is T => typeof value === 'string');

    for (const enumValue of allEnumValues) {
        if (!arr.includes(enumValue)) {
            throw new Error(`Array is missing enum value: ${enumValue}`);
        }
    }

    if (arr.length !== allEnumValues.length) {
        throw new Error('Array contains duplicate or extra values');
    }

    return arr;
}
